import { FETCH_NOTIFICATIONS } from './constants'

export const notificationFetched = (notification_list) => {
  return {
    type: FETCH_NOTIFICATIONS,
    notification_list
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/actions.js